import React, { useRef, useState } from "react";
import {
  MinMaxPlaceholder,
  RangeInput,
  SliderContainer,
  SliderPoint,
  SliderTrack,
  Title,
  Tooltip,
  TooltipArrow,
} from "./index.styled";
import { viewSizeCalculator } from "../../../utils";

const RatingSlider = ({ title, ratingPoints, showLabeledRating = false }) => {
  const [rating, setRating] = useState(2);
  const [showTooltip, setShowTooltip] = useState(false);
  const sliderContainerRef = useRef(null);

  const min = 1;
  const max = ratingPoints;
  const step = 1;

  const getPercent = (value) => ((value - min) / (max - min)) * 100;

  const handleChange = (e) => {
    setRating(Number(e.target.value));
  };

  const handleDotClick = (value) => {
    setRating(value);
  };

  const labelMap = ["Low", "Good", "Excellent"];
  const displayValue = showLabeledRating ? labelMap[rating - 1] : `${rating} ★`;

  const calculateTooltipPosition = (value) => {
    if (!sliderContainerRef.current) return "0%";

    const sliderWidth = sliderContainerRef.current.offsetWidth;
    const thumbWidth = 16;

    const percentage = ((value - min) / (max - min)) * 100;

    const adjustedPercentage =
      (percentage * (sliderWidth - thumbWidth)) / sliderWidth + 2.4;

    return `${adjustedPercentage}%`;
  };

  return (
    <SliderContainer ref={sliderContainerRef}>
      <Title>{title}</Title>
      <div style={{ position: "relative", marginTop: viewSizeCalculator(0.1) }}>
        <RangeInput
          type="range"
          min={min}
          max={max}
          step={step}
          value={rating}
          onChange={handleChange}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        />

        {showTooltip && (
          <Tooltip style={{ left: calculateTooltipPosition(rating) }}>
            <span>{displayValue}</span>
            <TooltipArrow />
          </Tooltip>
        )}

        <SliderTrack />
        {Array.from({ length: ratingPoints }, (_, index) => {
          const value = index + 1;
          const adjustedLeft =
            index === 0
              ? getPercent(index + 1) + 1.5
              : index === ratingPoints - 1
                ? getPercent(index + 1) - 1.5
                : getPercent(index + 1);
          return (
            <SliderPoint
              key={index}
              onClick={() => handleDotClick(value)}
              style={{
                position: "absolute",
                left: `${adjustedLeft}%`,
              }}
            />
          );
        })}
      </div>
      <MinMaxPlaceholder>
        {showLabeledRating ? (
          <>
            <p>Low</p>
            <p style={{ marginLeft: viewSizeCalculator(1.5) }}>Good</p>
            <p>Excellent</p>
          </>
        ) : (
          <>
            {Array.from({ length: ratingPoints }, (_, index) => (
              <p key={index}>{index + 1} ★</p>
            ))}
          </>
        )}
      </MinMaxPlaceholder>
    </SliderContainer>
  );
};

export default RatingSlider;
